import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/building-solutions-in-life-and-code',
    name: 'BuildingCodee',
    component: () => import('../components/blog/BuildingCodeBlog.vue')
  },
  {
    path: '/challenges-in-developing-kigali-airport-pickup',
    name: 'KigaliAirportPickup',
    component: () => import('../components/blog/ChallengeskigaliairportPickup.vue')
  },
  {
    path: '/product/kigali-self-drive',
    name: 'KigaliSelfDrive',
    component: () => import('../components/products/KigaliSelfDrive.vue')
  },
  {
    path: '/product/estate-rwanda',
    name: 'EstateRwanda',
    component: () => import('../components/products/EstateRwanda.vue')
  },
  {
    path: '/product/budgeting-app',
    name: 'BudgetingApp',
    component: () => import('../components/products/BudgetingApp.vue')
  },
  {
    path: '/product/kinezor',
    name: 'Kinezor',
    component: () => import('../components/products/Kinezor.vue')
  },
  {
    path: '/product/rwanda-car-hire',
    name: 'RwandaCarHire',
    component: () => import('../components/products/RwandaCarHire.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
